import { cn } from "../../../../../src/lib/utils";
import ButtonV2 from ".";

export interface ReturnButtonProps {
  label: string;
  onClick: () => void;
  disabled?: boolean;
  loading?: boolean;
  className?: string;
}

export const ReturnButton: React.FC<ReturnButtonProps> = ({
  label,
  onClick,
  disabled,
  loading,
  className,
}) => {
  return (
    <ButtonV2
      variant="outline"
      size="md"
      onClick={onClick}
      disabled={disabled}
      loading={loading}
      className={cn(
        "border-none bg-[#8C8C8C] text-white rounded-[8px]",
        "shadow-[0px_1px_2px_rgba(0,0,0,0.05)] transition-colors duration-150",
        "hover:bg-[color-mix(in_srgb,white_10%,#8C8C8C)] hover:text-white",
        "focus-visible:ring-[3px] focus-visible:ring-[#F4F4F5] focus-visible:ring-offset-0 focus-visible:outline-none",
        "active:opacity-60",
        className
      )}
    >
      {label}
    </ButtonV2>
  );
};